import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            {/* Contact Details Column */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="h6" component="div" gutterBottom>
                Contact Us
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon />
                <Typography variant="body2">
                Brown Road, Ludhiana, INDIA
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon />
                <Typography variant="body2">
                   +91-9115112720
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon />
                <Typography variant="body2">
                NZAROI2025@cmcludhiana.in
                </Typography>
              </Box>
            </Box>

            {/* Conference Logo Column */}
            <Box>
              <img
                src="/assets/conference-logo.png"
                alt="Conference Logo"
                style={{ height: '150px', width: 'auto' }}
              />
            </Box>
          </Box>

          <Box sx={{ mt: 2 }}>
            <iframe
              title="Conference Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3419.805931441123!2d75.8613814!3d30.9109722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a830bf1ec4613%3A0x69081642207ac46f!2sChristian%20Medical%20College%20%26%20Hospital!5e0!3m2!1sen!2sin!4v1711271234567!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Box>

          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
            © {new Date().getFullYear()} Designed by Manik Bansal. Contact: bansalmani0714@gmail.com
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 
